import { Eye, EyeOff } from 'lucide-react';
import { forwardRef, useState } from 'react';
import { cn } from '@/lib/utils/cn';
import { Icon } from './icon';
import { TextInput, type TextInputProps } from './text-input';

export type PasswordInputProps = Omit<TextInputProps, 'type'>;

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  function PasswordInput({ className, ...rest }, ref) {
    const [visible, setVisible] = useState(false);

    return (
      <div className="relative">
        <TextInput
          ref={ref}
          type={visible ? 'text' : 'password'}
          className={cn('pr-9', className)}
          {...rest}
        />
        <button
          type="button"
          tabIndex={-1}
          aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          onClick={() => {
            setVisible((v) => !v);
          }}
          className="text-fg-muted hover:text-fg absolute inset-y-0 right-0 flex items-center px-2.5 transition-colors disabled:pointer-events-none"
          disabled={rest.disabled}
        >
          <Icon icon={visible ? EyeOff : Eye} size="lg" />
        </button>
      </div>
    );
  },
);
